import { useEffect, useState } from "react";
import { detailTrainingParticipants } from "../../../config/apiSPA";
import { useParams } from "react-router-dom";
import { Card, CardBody, CardHeader } from "../../../components/card/card";
import TrainingParticipantTable from "./trainingReportParticipantComponent/table";
import TrainingParticipantToolbar from "./trainingReportParticipantComponent/toolbar";

function TrainingReportParticipant({ onUpdate = () => {} }) {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [participantData, setParticipantData] = useState([]);
  const loadData = async () => {
    try {
      const res = await detailTrainingParticipants(id);
      setParticipantData(res.data);
      setIsLoading(false);
    } catch (error) {}
  };
  const handleUpdate = (e) => {
    setParticipantData(e);
    onUpdate(e);
  };

  useEffect(() => {
    loadData();
  }, []);
  return (
    <>
      <Card className="mb-4">
        <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">Participants</CardHeader>
        <CardBody>
          <TrainingParticipantToolbar onChange={(e) => setParticipantData(e)} />
          <TrainingParticipantTable participantData={participantData} isLoading={isLoading} onUpdate={(e) => handleUpdate(e)} />
        </CardBody>
      </Card>
    </>
  );
}

export default TrainingReportParticipant;
